import { getAppCopy } from '../../../i18n';
import type { EntitlementStatus } from '../types';

export async function fetchNoopEntitlement(): Promise<EntitlementStatus> {
  return { tier: 'free', source: 'cache' };
}

export async function purchaseNoop(): Promise<void> {
  throw new Error(getAppCopy().billingErrors.purchaseUnavailable);
}

export async function restoreNoop(): Promise<boolean> {
  return false;
}

export async function manageNoop(): Promise<void> {
  throw new Error(getAppCopy().billingErrors.manageUnavailable);
}
